import { createSelector } from 'reselect';
import { entitiesSelector } from '../App/selectors';

export const matchByIdSelector = (id: string) =>
  createSelector(
    entitiesSelector,
    entities => entities.MATCHES[id],
  );
